import React, { Dispatch } from 'react';
import { FormControl } from '@material-ui/core';
import { useTypedTranslation } from '@app/hooks';
import { OTP_PASSCODE_LENGTH } from '@app/constants';
import { validateInput, returnInputNumber } from '@app/helpers';
import { ActiveMethodManageMfa } from '@app/models';
import { MethodsMfa } from '@app/enums';
import { PasslyTextField } from '@app/components';

interface IProps {
    activeMethod: ActiveMethodManageMfa;
    setPassCode: Dispatch<string>;
    passCode: string;
    setErrorMessage: Dispatch<string>;
    errorMessage: string;
}

export const handleChangeInput =
    (setPassCode: Dispatch<string>, errorMessage: string, setErrorMessage: Dispatch<string>) => (e: React.ChangeEvent<HTMLInputElement>) => {
        if (validateInput(OTP_PASSCODE_LENGTH, e.target.value)) {
            setPassCode(returnInputNumber(e.target.value));
        }

        if (errorMessage) {
            setErrorMessage('');
        }
    };

export const Verify: React.SFC<IProps> = ({ setPassCode, activeMethod, passCode, setErrorMessage, errorMessage }) => {
    const { translation } = useTypedTranslation();

    return (
        <>
            <div className='manage-mfa-token__part manage-mfa-token__part-3'>3.{' '}
                {activeMethod !== MethodsMfa.yubikey ? (
                    translation('MOBILE_APP_ENTER_QR_CODE_STEP_3_PART_2')
                ) : (
                    translation('MFA_CONFIGURED_YUB_JUST_VERIFY_PASSCODE_DESC')
                )}
            </div>
            <FormControl className='manage-mfa-token__passcode--input'>
                <PasslyTextField
                    fullWidth
                    className='manage-mfa-token__input'
                    name='passCode'
                    value={passCode}
                    onChange={handleChangeInput(setPassCode, errorMessage, setErrorMessage)}
                    id='displayName-input'
                    error={!!errorMessage}
                    helperText={errorMessage}
                    required
                />
            </FormControl>
        </>
    );
};
